import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../services/api/axios.config";
import { notify } from "../utils/methods/notification";

const initialState = {
    module: [],
    process: [],
    isReadonly: '',
    loading: false,
    allModules: [],
    allProcessList: [],
    allProcessListById: [],
    processListByModuleId: [],
    detailOfFaq: [],
    viewSingleHelpDetails: [],
    storeSubjectData:{},
    storeSlugs:'',
    storeSechedule:false
}
// fetch all the sub-module listing
export const fetchAllModules = createAsyncThunk(
    'bmr/fetchAllModules',
    async (_, { rejectWithValue }) => {
        try {
            const response = await api.get('/faq/modules-submodules/list');
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// fetch all the Process listing
export const fetchAllProcessList = createAsyncThunk(
    'bmr/fetchAllProcessListing',
    async ({ id, search } = {}, { rejectWithValue }) => {
        try {
            const response = await api.get('/faq/help/process/list', {
                params: {
                    ...(id !== undefined && { id }),
                    ...(search !== undefined && { search })
                }
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// fetch all the listing for processes
export const listingByProcessId = createAsyncThunk(
    'bmr/fetchlistingByProcessId',
    async ({ params, fromModal = false }, { rejectWithValue }) => {
      if (!params?.id) {
        return rejectWithValue('Process ID is required');
      }
      try {
        const response = await api.get(`/faq/get/faq-by-process-id`, { params });
        return { data: response?.data, fromModal };
      } catch (error) {
        return rejectWithValue(error.response ? error.response.data : error.message);
      }
    }
  );

// fetch all processe according to module ID
export const processesByModuleId = createAsyncThunk(
    'bmr/fetchProcessesByModuleId',
    async (id, { rejectWithValue }) => {
        try {
            const response = await api.get(`/faq/get/process-by-module-id?id=${id}`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// create new FAQ
export const addNewFaq = createAsyncThunk(
    'bmr/addNewFaq',
    async (args, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.post(`/faq/help/create`, args);
            notify.success(response.data.message);
            await dispatch(listingByProcessId({ id: args.help_process_id, status: -1 }))

            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// fetch single FAQ with the respective of ID
export const viewDetailFaq = createAsyncThunk(
    'bmr/viewDetailFaq',
    async (id, { rejectWithValue }) => {
        try {
            const response = await api.get(`/faq/get/by-faq-id?id=${id}`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// delete the FAQ
export const deleteFaQ = createAsyncThunk(
    'bmr/faqDelete',
    async (arg, { rejectWithValue, dispatch }) => {
        const { payload } = arg
        try {
            const response = await api.delete(`/faq/help?id=${payload.id}`);
            notify.success(response.data.message);
            await dispatch(listingByProcessId({ id: payload.proc_ID, status: -1, }))

            return response.data;
        } catch (error) {
            notify.error(error?.message || error);
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// handle Update FAQ
export const updateFaq = createAsyncThunk(
    'bmr/updateFaq',
    async (args, { rejectWithValue, dispatch }) => {
        const { payload } = args
        try {
            const response = await api.post(`/faq/help/update`, payload);
            notify.success(response.data.message);
            await dispatch(listingByProcessId({ id: payload.help_process_id, status: -1 }))

            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// Enable and disable the Process
export const updateProcess = createAsyncThunk(
    'bmr/updateProcess',
    async (args, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.put(`/faq/help/process/update`, args);
            notify.success(response.data.message);
            await dispatch(fetchAllProcessList())

            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// // handle Update FAQ

export const updateSequence = createAsyncThunk(
    'bmr/updateSequenceList',
    async (args, { rejectWithValue }) => {
        const { sequences } = args
        try {
            const response = await api.post(`/faq/help/update/sequence`, sequences);
            // await dispatch(listingByProcessId({ id: process_id, status: -1 }))
            notify.success(response.data.message);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// handle the view Help by the slugs on other panels
export const viewHelpBySlug = createAsyncThunk(
    'bmr/viewHelpBySlug',
    async (slugs, { rejectWithValue }) => {
    let slug = { slug: slugs};
        try {
            const response = await api.post(`/faq/help/get-by-slug`, slug);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);
//add payment status
export const modeOfPaymentStatus = createAsyncThunk(
    'bmr/logistics/payment-status',
    async (args, { rejectWithValue }) => {
        const {id, data } = args
        try {
            const response = await api.patch(`/logistics/payment-status/${id}`, data);
            // await dispatch(listingByProcessId({ id: process_id, status: -1 }))
            notify.success(response.data.message);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);
const bmrHelpSlice = createSlice({
    name: 'bmrHelp',
    initialState,
    reducers: {
        enableModule(state, action) {
            state.module = action.payload;
        },
        disableModule(state) {
            state.module = []
        },
        enableProcess(state, action) {
            state.process = action.payload;
        },
        disableProcess(state) {
            state.process = [];
        },
        enableIsReadonly(state) {
            state.isReadonly = true;
        },
        disableIsReadonly(state) {
            state.isReadonly = false;
        },
        emptyallProcessListsById(state) {
            state.allProcessListById = []
        },
        clearDetailOfFaq(state) {
            state.detailOfFaq = []
        },
        setSlugs(state, action){
            state.storeSlugs=action.payload
        },
        setSechedule(state,action){
         state.storeSechedule=action.payload
        },
        setSubjectDataList(state,action){
         state.storeSubjectData=action.payload
        },
        clearSlugs(state){
            state.storeSlugs=''
        },
        clearSechedule(state){
            state.storeSechedule=false
        },
        clearSubjectDataList(state){
         state.storeSubjectData={}
        },
    },
    extraReducers: (builder) => {
        builder
            // handle slices fetch all the sub-module listing
            .addCase(fetchAllModules.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchAllModules.fulfilled, (state, action) => {
                state.loading = false;
                state.allModules = action.payload.data
            })
            .addCase(fetchAllModules.rejected, (state) => {
                state.loading = false;
            });

        // handle slice of fetch all process list
        builder
            .addCase(fetchAllProcessList.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchAllProcessList.fulfilled, (state, action) => {
                state.loading = false;
                state.allProcessList = action.payload.data
            })
            .addCase(fetchAllProcessList.rejected, (state) => {
                state.loading = false;
            });

        builder
            .addCase(listingByProcessId.pending, (state) => {
                state.loading = true;
            })
            .addCase(listingByProcessId.fulfilled, (state, action) => {
                state.loading = false;
                if (!action.payload.fromModal) {
                    state.allProcessListById = action.payload.data.data;
                }
            })
            .addCase(listingByProcessId.rejected, (state) => {
                state.loading = false;
            });

        //handle slice for fetch all processe according to module ID
        builder
            .addCase(processesByModuleId.pending, (state) => {
                state.loading = true;
            })
            .addCase(processesByModuleId.fulfilled, (state, action) => {
                state.loading = false;
                state.processListByModuleId = action.payload.data
            })
            .addCase(processesByModuleId.rejected, (state) => {
                state.loading = false;
            });
        // handle slice to add new FAQ
        builder
            .addCase(addNewFaq.pending, (state) => {
                state.loading = true;
            })
            .addCase(addNewFaq.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(addNewFaq.rejected, (state) => {
                state.loading = false;
            });

        // handle slice for fetch single FAQ with the respective of ID

        builder
            .addCase(viewDetailFaq.pending, (state) => {
                state.loading = true;
            })
            .addCase(viewDetailFaq.fulfilled, (state, action) => {
                state.loading = false;
                state.detailOfFaq = action.payload.data
            })
            .addCase(viewDetailFaq.rejected, (state) => {
                state.loading = false;
            });
        // handle slice for the delete FAQ.
        builder
            .addCase(deleteFaQ.pending, (state) => {
                state.loading = true;
            })
            .addCase(deleteFaQ.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(deleteFaQ.rejected, (state) => {
                state.loading = false;
            });
        // handle slice to update the FAQ
        builder
            .addCase(updateFaq.pending, (state) => {
                state.loading = true;
            })
            .addCase(updateFaq.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(updateFaq.rejected, (state) => {
                state.loading = false;
            });
        // handle Enable and disabled Processes
        builder
            .addCase(updateProcess.pending, (state) => {
                state.loading = true;
            })
            .addCase(updateProcess.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(updateProcess.rejected, (state) => {
                state.loading = false;
            });
        // handle update the sequence
        builder
            .addCase(updateSequence.pending, (state) => {
                state.loading = true;
            })
            .addCase(updateSequence.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(updateSequence.rejected, (state) => {
                state.loading = false;
            });
        // slice for handle the view Help by the slugs on other panels

        builder
            .addCase(viewHelpBySlug.pending, (state) => {
                state.loading = true;
            })
            .addCase(viewHelpBySlug.fulfilled, (state, action) => {
                state.viewSingleHelpDetails = action.payload.data
                state.loading = false;
            })
            .addCase(viewHelpBySlug.rejected, (state) => {
                state.loading = false;
            });
    }
})

export const {clearSubjectDataList, setSubjectDataList, enableModule, disableModule, enableProcess, disableProcess, enableIsReadonly, disableIsReadonly, emptyallProcessListsById, clearDetailOfFaq, setSlugs, setSechedule, clearSlugs, clearSechedule  } = bmrHelpSlice.actions
export const selectedSubjectData = (state) => state.bmrHelp.storeSubjectData;
export const selectedModule = (state) => state.bmrHelp.module;
export const selectedProcess = (state) => state.bmrHelp.process;
export const Loading = (state) => state.bmrHelp.loading;
export const isReadonlyFeild = (state) => state.bmrHelp.isReadonly;
export const allModules = (state) => state.bmrHelp.allModules;
export const allProcessLists = (state) => state.bmrHelp.allProcessList;
export const allProcessListsById = (state) => state.bmrHelp.allProcessListById;
export const allprocessListByModuleId = (state) => state.bmrHelp.processListByModuleId;
export const processDetail = (state) => state.bmrHelp.detailOfFaq;
export const viewHelpDetailsBySlugs = (state) => state.bmrHelp.viewSingleHelpDetails;



export default bmrHelpSlice.reducer;
